export default "__VITE_ASSET__BNazoD6M__"